import { CASH_FLOW_MODULE_URL } from "src/modules/sales/modules/cash-flow/constant/contact.module-config";

export const CASH_OUT_CATEGORY_MODULE_NAME = "Danh mục phiếu chi";
export const CASH_OUT_CATEGORY_MODULE_URL =
  CASH_FLOW_MODULE_URL + "/cash-out-category";
export const CASH_OUT_CATEGORY_API_PATH = "/v1/cash-out-category";
